<template lang="pug">
  .columns.mt-2.pt-2
    .column.col-12.bg-gray.p-1 Alvará
    .columns.column.col-12.mt-1
      .column.col-3.col-sm-12.mt-1
        div
          .text-small {{ 'cadastro_economico.alvara_numero' | tModel }}
          .text-bold {{ economico.alvara_numero }}
      .column.col-3.col-sm-12.mt-1
        div
          .text-small {{ 'cadastro_economico.alvara_protocolo_numero' | tModel }}
          .text-bold {{ economico.alvara_protocolo_numero }}
      .column.col-3.col-sm-12.mt-1
        div
          .text-small {{ 'cadastro_economico.alvara_expedido_em' | tModel }}
          .text-bold {{ economico.alvara_expedido_em | date('DD/MM/YYYY')  }}
      .column.col-3.col-sm-12.mt-1
        div
          .text-small {{ 'cadastro_economico.alvara_vence_em' | tModel }}
          .text-bold {{ economico.alvara_vence_em | date('DD/MM/YYYY') }}

    .column.col-12.bg-gray.p-1.mt-2 {{ 'cadastro_economico.atividade' | tModel }}
    .columns.column.col-12.mt-1
      .column.col-12.mt-1
        div
          .text-small {{ 'cadastro_economico.atividade' | tModel }}
          .text-bold {{ economico.atividade || '-' }}
      .column.col-12.mt-1
        div Atividades
        .py-2(v-for='atividade in economico.atividades')
          b {{ atividade.codigo }}
          |  - {{ atividade.descricao }}

    .column.col-12.bg-gray.p-1.mt-2 Auditoria
    .columns.column.col-12.mt-1
      .column.col-6.col-sm-12.mt-1
        div
          .text-small {{ 'cadastro_economico.auditoria_inicio_em' | tModel }}
          .text-bold {{ economico.auditoria_inicio_em | date }}
      .column.col-6.col-sm-12.mt-1
        div
          .text-small {{ 'cadastro_economico.auditoria_final_em' | tModel }}
          .text-bold {{ economico.auditoria_final_em | date }}

</template>

<script>
import { vuexDefaultMapping } from '@/mixins/show'

export default {
  vuex: { cadastros: vuexDefaultMapping },
  computed: {
    economico() {
      return this.current.cadastro_economico
    },
  },
}
</script>
